import styled from 'styled-components';
import { PrimaryLinkButton } from 'styles/common';
import { mediaSm } from 'theme/theme-helper-selectors';

export const Container = styled.div`
    position: relative;
    z-index: 20;
    background: linear-gradient(180deg, #e5f7f4 0%, #ffffff 25%);
`;

export const Content = styled.div`
    position: relative;
    min-height: 562px;
    width: 100%;
    padding: 80px 0px;
    display: flex;
    flex-direction: column;
    padding-right: 170px;
    align-items: flex-start;

    @media (${mediaSm}) {
        padding: 170px 0px 300px 0px;
    }
`;

export const Description = styled.p`
    font-size: 72px;
    font-weight: 400;
    line-height: 72px;
    max-width: 870px;
    font-weight: 500;

    @media (${mediaSm}) {
        font-size: 32px;
        font-weight: 500;
        line-height: 36px;
    }
`;

export const VacancyButton = styled(PrimaryLinkButton)`
    margin-top: 40px;
`;

export const Coral = styled.img`
    position: absolute;
    left: -43%;
    bottom: -13%;

    @media (${mediaSm}) {
        width: 300px;
        bottom: -45px;
        left: 50%;
        transform: translateX(-50%);
    }
`;
